export const ru = {
    action_submit: 'Отозвать',
    revoke_from: 'У сотрудников',
    title: 'Отозвать роль координатора',
};
